/**
 * Created by Carsten Bühler
 * User: c.buehler on 09.08.2018
 * Copyright: xdot GmbH 2018
 */
import React from 'external/react';
import PropTypes from 'external/prop-types';

import {
    AppContext,
    DataUtil,
    FormActions,
    UidUtil,
    wrapWithCommonFormContainer
} from 'plugin/liferay-widgets-react-web';
import { getSubscriptionStore } from '../stores/StoreFactory';
import SubscriptionActions from '../actions/SubscriptionActions';
import { DataNames } from '../constants/Constants';
import MultiSubscriptionEditForm from './MultiSubscriptionEditForm';

import { Button } from 'external/react-bootstrap';

const SubscriptionStore = getSubscriptionStore(AppContext);

const MultiSubscriptionEditFormHoc = wrapWithCommonFormContainer(MultiSubscriptionEditForm);

class EditMultiUserSubscriptionButton extends React.Component {

    constructor(props) {
        super(props);

        this.DATA = {
            USER_SUBSCRIPTIONS: DataNames.UserSubscriptions,
            FORM_MULTI_SUBSCRIBE_CONFIRM: UidUtil.generateId('FORM_MULTI_SUBSCRIBE_CONFIRM')
        };

        this.removeListener = SubscriptionStore.addListener(this.onChange.bind(this));

        this.onSubscribe = this.onSubscribe.bind(this);
        this.onSubscribeConfirm = this.onSubscribeConfirm.bind(this);
        this.getSubscriptions = this.getSubscriptions.bind(this);

        this.state = {
            'userSubscriptions': this.getSubscriptions(),
            'userMultiSubscriptions': this.getUserMultiSubscriptions()
        };

    }

    componentDidMount() {
        if (!this.getSubscriptions()) {
            SubscriptionActions.mySubscriptionsNeeded();
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.topics !== this.props.topics) {
            let userMultiSubscriptions = this.getUserMultiSubscriptions();
            this.setState({
                userMultiSubscriptions
            });
        }
    }

    onChange() {
        const userSubscriptionsDataItem = this.getSubscriptions();
        let userMultiSubscriptions = this.getUserMultiSubscriptions();

        this.setState({
            'userSubscriptions': userSubscriptionsDataItem,
            'userMultiSubscriptions': userMultiSubscriptions
        });
    }

    getUserMultiSubscriptions() {
        const userSubscriptions = DataUtil.asArray(this.getSubscriptions());
        return userSubscriptions ? userSubscriptions.filter(sub => this.props.topics.includes(sub.topic)) : undefined;
    }

    getSubscriptions() {
        return SubscriptionStore.getRemoteData(this.DATA.USER_SUBSCRIPTIONS);
    }

    getFormSubscriptions() {
        const { objectTitle, topics } = this.props;
        const { userMultiSubscriptions } = this.state;

        return topics.map(topic => {
            const subscription = {
                title: objectTitle,
                topic: topic,
                channels: []
            };

            const matchingSubscription = userMultiSubscriptions.find(sub => sub.topic === topic);

            if (matchingSubscription) {
                subscription.channels = matchingSubscription.channels;
            }

            return subscription;
        });
    }

    onSubscribe(e) {
        FormActions.startEditFormItem(this.DATA.FORM_MULTI_SUBSCRIBE_CONFIRM, {
            subscriptions: this.getFormSubscriptions()
        });
    }

    onSubscribeConfirm(formData) {
        SubscriptionActions.addOrUpdateOrDeleteMultiSubscription({
            subscriptions: formData.subscriptions,
        }, this.DATA.FORM_MULTI_SUBSCRIBE_CONFIRM, true);
    }

    componentWillUnmount() {
        if (this.removeListener) {
            this.removeListener.remove();
        }
    }

    render() {
        const { objectTitle, title } = this.props;
        const buttonTitle = 'Abonnement bearbeiten: ' + objectTitle;

        return (
            <React.Fragment>
                <Button
                    variant={'primary'}
                    onClick={this.onSubscribe}
                    title={buttonTitle}
                >
                    {title}
                </Button>

                <MultiSubscriptionEditFormHoc
                    formId={this.DATA.FORM_MULTI_SUBSCRIBE_CONFIRM}
                    onFormSubmit={this.onSubscribeConfirm}
                />
            </React.Fragment>
        );
    }

}

EditMultiUserSubscriptionButton.propTypes = {
    topics: PropTypes.PropTypes.arrayOf(PropTypes.string).isRequired,
    title: PropTypes.string.isRequired,
    objectTitle: PropTypes.string.isRequired
};

export default EditMultiUserSubscriptionButton;



// WEBPACK FOOTER //
// ./js/components/EditMultiSubscriptionButton.jsx